var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.argumentsAreValid
    ? _c("div", { staticClass: "upgradeformatversion" }, [
        _vm.isLoading
          ? _c("div", [_vm._v("\n    Loading...\n  ")])
          : _c("div", [
              _c("h2", [_vm._v("Campaign")]),
              _vm._v(" "),
              _c("span", { staticClass: "headline__sub" }, [
                _vm._v("Parameters")
              ]),
              _vm._v(" "),
              _vm.newCampaignParameters.length > 0
                ? _c("div", [
                    _vm._v(
                      "\n      After upgrading, the campaign will have the parameters listed below:\n      "
                    ),
                    _vm.newCampaignParameters.length > 0
                      ? _c("table", { staticClass: "parameters simpletable" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.newCampaignParameters, function(item) {
                              return _c("tr", { key: item.id }, [
                                _c(
                                  "td",
                                  { staticClass: "parameters-parameter" },
                                  [_vm._v(_vm._s(_vm.getDescription(item.tag)))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "parameters-defaultValue" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.getDisplayValue(item.value))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isNew(item)
                                  ? _c("td", [_c("span", [_vm._v("NEW")])])
                                  : _vm._e()
                              ])
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.removedParameters.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "v-alert",
                        { staticClass: "block", attrs: { type: "warning" } },
                        [_vm._v("Some parameters have been removed")]
                      ),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        {
                          model: {
                            value: _vm.formValid,
                            callback: function($$v) {
                              _vm.formValid = $$v
                            },
                            expression: "formValid"
                          }
                        },
                        [
                          _vm.removedParameters.length > 0
                            ? _c(
                                "table",
                                { staticClass: "parameters block simpletable" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th"),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v(
                                          "\n                Parameter\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v(
                                          "\n                Value\n              "
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.removedParameters, function(
                                      item
                                    ) {
                                      return _c("tr", { key: item.id }, [
                                        _c(
                                          "th",
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                rules: [_vm.mustAcceptDeletion]
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "parameters-parameter"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getDescription(item.tag)
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "parameters-defaultValue"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.getDisplayValue(item))
                                            )
                                          ]
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                : _c("div", { staticClass: "block" }, [
                    _vm._v("No parameters has been removed.")
                  ]),
              _vm._v(" "),
              _vm.latestFormatVersion &&
              _vm.campaign &&
              (_vm.campaign.width !== _vm.latestFormatVersion.width ||
                _vm.campaign.height !== _vm.latestFormatVersion.height)
                ? _c("div", { staticClass: "block" }, [
                    _c("span", { staticClass: "headline__sub" }, [
                      _vm._v("Width and height settings")
                    ]),
                    _vm._v(
                      "\n      The height and/or width has been updated on the format. If ypou want to use the new height/width, you must update your campaign manually."
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("table", { staticClass: "simpletable" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("Format")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.latestFormatVersion.width))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.latestFormatVersion.height))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("Campaign")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.campaign.width))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.campaign.height))])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm._l(_vm.updatedCanvasContent, function(canvasContent) {
                    return _c("div", [
                      _c("h2", [
                        _vm._v(
                          _vm._s(canvasContent.bannerPlaceholder.description)
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "headline__sub" }, [
                        _vm._v("Parameters")
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n          After upgrading, the content format will have the parameters listed below:\n          "
                        ),
                        canvasContent.parameters.length > 0
                          ? _c(
                              "table",
                              { staticClass: "parameters simpletable" },
                              [
                                _vm._m(3, true),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(canvasContent.parameters, function(
                                    item
                                  ) {
                                    return _c("tr", { key: item.id }, [
                                      _c(
                                        "td",
                                        { staticClass: "parameters-parameter" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getCanvasContentParamDescription(
                                                item
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "parameters-defaultValue"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getDisplayValue(item.value)
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isNewCanvasContentParam(item)
                                        ? _c("td", [
                                            _c("span", [_vm._v("NEW")])
                                          ])
                                        : _vm._e()
                                    ])
                                  }),
                                  0
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.removedCanvasContentParams.get(
                        canvasContent.bannerPlaceholder.tag
                      ).length
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-alert",
                                {
                                  staticClass: "block",
                                  attrs: { type: "warning" }
                                },
                                [_vm._v("Some parameters have been removed")]
                              ),
                              _vm._v(" "),
                              _vm._m(4, true),
                              _vm._v(" "),
                              _c(
                                "v-form",
                                {
                                  model: {
                                    value: _vm.formValid,
                                    callback: function($$v) {
                                      _vm.formValid = $$v
                                    },
                                    expression: "formValid"
                                  }
                                },
                                [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "parameters block simpletable"
                                    },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th"),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { staticClass: "text-left" },
                                            [
                                              _vm._v(
                                                "\n                    Parameter\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { staticClass: "text-left" },
                                            [
                                              _vm._v(
                                                "\n                    Value\n                  "
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.removedCanvasContentParams.get(
                                            canvasContent.bannerPlaceholder.tag
                                          ),
                                          function(item) {
                                            return _c("tr", { key: item.id }, [
                                              _c(
                                                "th",
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      rules: [
                                                        _vm.mustAcceptDeletion
                                                      ]
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "parameters-parameter"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getCanvasContentParamDescription(
                                                        item
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "parameters-defaultValue"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getDisplayValue(
                                                        item.value
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.newCanvasPlaceholders, function(
                    bannerPlaceholder
                  ) {
                    return _c("div", [
                      _c("h2", [
                        _vm._v("NEW: " + _vm._s(bannerPlaceholder.description))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "block" }, [
                        _vm._v(
                          "This is a new placeholder that has been added to the format. Make sure to select a banner for it."
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _vm.removedCanvasContent.length > 0
                    ? _c(
                        "div",
                        [
                          _c("h2", [_vm._v("Removed placeholders")]),
                          _vm._v(" "),
                          _c(
                            "v-alert",
                            {
                              staticClass: "block",
                              attrs: { type: "warning" }
                            },
                            [_vm._v("Some placeholders have been removed")]
                          ),
                          _vm._v(" "),
                          _vm._m(5),
                          _vm._v(" "),
                          _c(
                            "v-form",
                            {
                              model: {
                                value: _vm.formValid,
                                callback: function($$v) {
                                  _vm.formValid = $$v
                                },
                                expression: "formValid"
                              }
                            },
                            [
                              _c(
                                "table",
                                { staticClass: "parameters block simpletable" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th"),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v(
                                          "\n                  Placeholder\n                "
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.removedCanvasContent, function(
                                      item
                                    ) {
                                      return _c("tr", { key: item.id }, [
                                        _c(
                                          "th",
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                rules: [_vm.mustAcceptDeletion]
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "parameters-parameter"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.bannerPlaceholder
                                                  .description
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _c("div", { staticClass: "block" }, [
                        _vm._v("No placeholders have been removed.")
                      ])
                ],
                2
              ),
              _vm._v(" "),
              _vm.newCampaignParameters.length > 0
                ? _c("div", { staticClass: "block" }, [
                    _c("span", [
                      _vm._v(
                        "Click upgrade to transfer the changes to your campaign."
                      )
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Remember to fill out the parameter values and save/publish the campaign as normal."
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", disabled: !_vm.formValid },
                      on: { click: _vm.upgrade }
                    },
                    [_vm._v("Upgrade")]
                  ),
                  _vm._v(" "),
                  _c("v-btn", { on: { click: _vm.close } }, [_vm._v("Cancel")])
                ],
                1
              )
            ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left" }, [
          _vm._v("\n              Parameter\n            ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left" }, [
          _vm._v("\n              Value\n            ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "block" }, [
      _vm._v(
        "\n        The parameters displayed below have been removed in the new version."
      ),
      _c("br"),
      _vm._v(
        "\n        Please go through them below, and mark the checkbox to acknowledge they will be deleted from your campaign, if you upgrade.\n      "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th"),
      _vm._v(" "),
      _c("th", [_vm._v("Width")]),
      _vm._v(" "),
      _c("th", [_vm._v("Height")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left" }, [
          _vm._v("\n                  Parameter\n                ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left" }, [
          _vm._v("\n                  Value\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "block" }, [
      _vm._v(
        "\n            The parameters displayed below have been removed in the new placeholder version."
      ),
      _c("br"),
      _vm._v(
        "\n            Please go through them below, and mark the checkbox to acknowledge they will be deleted from your campaign, if you upgrade.\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "block" }, [
      _vm._v(
        "\n          The placeholders displayed below have been removed in the new version."
      ),
      _c("br"),
      _vm._v(
        "\n          Please go through them below, and mark the checkbox to acknowledge they will be deleted from your campaign, if you upgrade.\n        "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }